import { render, staticRenderFns } from "./PrintableInpatientAuditReport.vue?vue&type=template&id=388e6874&scoped=true&"
import script from "./PrintableInpatientAuditReport.vue?vue&type=script&lang=js&"
export * from "./PrintableInpatientAuditReport.vue?vue&type=script&lang=js&"
import style0 from "./PrintableInpatientAuditReport.vue?vue&type=style&index=0&id=388e6874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e6874",
  null
  
)

export default component.exports